import { render, staticRenderFns } from "./DialogAvaliacaoFrentista.vue?vue&type=template&id=136ce0a4&"
import script from "./DialogAvaliacaoFrentista.vue?vue&type=script&lang=js&"
export * from "./DialogAvaliacaoFrentista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports